// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__2AJCr"};